/// <reference path="aiChat.module.ts" />

module Meevo.Components.AiChat {

    export interface IAiChatOptions {
        color: string;
        userName: string;
        mode: string;
        isMsiUser: boolean;
    }

    export interface IAiChatService {
        baseUrl: string;
        ensureElement(options: IAiChatOptions): HTMLElement;
        attachTo(hostId: string): void;
        detach(): void;
        restart(options: IAiChatOptions): void;
    }

    export class AiChatService implements IAiChatService {
        static $inject = [];

        public static readonly HOST_ID = 'ai-chat-host';
        public static readonly MODAL_HOST_ID = 'ai-chat-modal-host';

        public baseUrl: string = window["MeevoAIMicroserviceUrl"] || "https://ai.meevo.com";
        private element: HTMLElement = null;

        ensureElement(options: IAiChatOptions): HTMLElement {
            if (!this.element) {
                const el = document.createElement('meevo-ai-chat');
                el.setAttribute('color', options.color);
                el.setAttribute('name', options.userName);
                el.setAttribute('mode', options.mode);
                el.setAttribute('api', this.baseUrl);
                el.setAttribute('internal', String(options.isMsiUser));
                this.element = el;
            }
            return this.element;
        }

        attachTo(hostId: string): void {
            if (!this.element) return;
            const host = document.getElementById(hostId);
            if (!host) return;
            // Reparenting a custom element preserves all internal state
            host.appendChild(this.element);
        }

        detach(): void {
            if (this.element && this.element.parentNode) {
                this.element.parentNode.removeChild(this.element);
            }
        }

        restart(options: IAiChatOptions): void {
            // Destroy and recreate — only used for genuine conversation resets
            this.detach();
            this.element = null;
            sessionStorage.removeItem("mil:meevo:chatresume");
            sessionStorage.removeItem("mil:meevo:lastanswer");
            this.ensureElement(options);
        }

        static factory(): Function {
            let svc = () => new AiChatService();
            svc.$inject = [];
            return svc;
        }
    }

    angular.module("meevo.components.aichat")
        .factory("meevo.components.aichat.AiChatService", AiChatService.factory());
}
